import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import JobQuerySearchPanel from 'Components/JobQuerySearchPanel';
import moment from 'moment';
import queryString from 'query-string';
import $ from 'jquery';
import _ from 'lodash';
import Navigation from 'Components/Navigation';
import EmailForm from 'Components/EmailForm';
import "@progress/kendo-theme-bootstrap/dist/all.css";
import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import { accountService, userService, jobService } from '../_services';
import { withAuthenticatedUser } from 'Components/withAuthenticatedUser';
import { withRouter } from 'Components/withRouter';
import styles from './QueryPage.module.css';

class DateTimeCell extends React.Component {
    render() {
        const value = this.props.dataItem[this.props.field];

        return (
            <td colSpan="1">{value ? moment(value).format("DD/MM, HH:mm") : null}</td>
        );
    }
}

class TotalPriceCell extends React.Component {
    render() {
        const value = (this.props.dataItem.vfr || 0)
            + (this.props.dataItem.price || 0);
        var that = this;
        return (
            <td colSpan="1">{this.props.that.formatter.format(value)}</td>
        );
    }
}

const TotalPriceWithMarkupCell = ({
    dataItem: {
        price,
        vfr,
        markup_percentage
    },
    formatter
}) => {

    return (
        <td colSpan="1">{formatter?.format((price + vfr) * (1 + (markup_percentage || 0.0) / 100))}</td>
    )
}

class JobLinkCell extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasUrl: "no",
            url:null
        }
    }
    
    render() {
        const job_number = this.props.dataItem[this.props.field];
        const job_id = this.props.dataItem["job_id"];
        return (
            <td colSpan="1">
                <Link to={"/job?id="+job_id}>{job_number}</Link>
            </td>
        );
    }
}

class QueryPage extends React.Component {

    constructor(props) {
        super(props);

        this.fetchData = this.fetchData.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);

        this.formatter = new Intl.NumberFormat('en-NZ', { style: 'currency', currency: 'NZD' });

        var state = {
            jobs: { data: [], total: 0 },
            dataState: { take: 25, skip: 0, sort: [] },
            accountOptions: null,
            showTotalWithMarkup: false
        };

        var query = this.getPreviousQuery();

        if (query) {
            Object.assign(state, {
                dataState: {
                    take: query.take,
                    skip: query.skip,
                    sort: query.sort || []
                }
            });
        }

        this.state = state;

        this.onSendEmail = this.onSendEmail.bind(this);
        this.getAccountOptions = this.getAccountOptions.bind(this);
        this.handleAccountChanged = this.handleAccountChanged.bind(this);
    }

    transformFormDataToQuery(formData) {
        var query = { account: this.state.account };

        formData.forEach((value, key) => {
            
            if (key === "from_date" || key === "to_date" ) {
                query[key] = moment(value,"DD/MM/YYYY").format("YYYY-MM-DD");
            } else {
                query[key] = value;
            }
            
        });

        return query;
    }

    onFormSubmit(formData) {
        
        this.fetchData(this.state.dataState, this.transformFormDataToQuery(formData));

    }
    
    fetchData(dataState, query) {

        userService.getJobs(query, dataState)
            .then(response => {
                this.setState(Object.assign(this.state, {
                    jobs: { data: response.jobs, total: response.total },
                    showTotalWithMarkup: this.state.accountOptions?.include_price_markup
                }));

                this.props.router.navigate('/query', {
                    replace: true,
                    state: {
                        query: query
                    }
                });
            })
            .catch(error => {
                console.log(error);
                this.setState({
                    jobs: { data: [], total: 0 },
                });
            });
    }
    
    handleDataStateChange = (changeEvent) => {
        this.setState({ dataState: changeEvent.data });

        const formData = new FormData(document.getElementById('form-query'));
        this.fetchData(changeEvent.data, this.transformFormDataToQuery(formData));
    }
    
    getPreviousQuery() {
        if (this.props.router.navigate &&
            this.props.router.navigate.location &&
            this.props.router.navigate.location.state &&
            this.props.router.navigate.location.state.query) {

            var query = this.props.router.navigate.location.state.query;
            return query;
        }
    }

    componentDidMount() {

        var query = this.getPreviousQuery();

        if (query) {
            
            var dataState = {
                take: query.take,
                skip: query.skip,
                sort: query.sort || []
            };

            delete query.take;
            delete query.skip;
            delete query.sort;

            this.fetchData(dataState, query);
        }

        $(document).on("keydown", ":input:not(textarea):not(:submit)", function(event) {
            if (event.key == "Enter") {
                event.preventDefault();
            }
        });

        this.getAccountOptions(this.props.authenticatedUser?.default_account);
    }
    
    DateTimeCell = (props) => <DateTimeCell {...props} />
    JobLinkCell = (props) => <JobLinkCell {...props} />
    TotalPriceCell = (props) => <TotalPriceCell {...props} that={this} />
    TotalPriceWithMarkupCell = (props) => <TotalPriceWithMarkupCell {...props} formatter={this.formatter} />

    onSendEmail(email_address) {
        
        const formData = new FormData(document.getElementById('form-query'));

        var data = {
            em_address: email_address
        };

        formData.forEach((value, key) => {
            if (key === 'from_date' || key === 'to_date')
                data[key] = moment(value, "DD/MM/YYYY").toISOString(true)
            else
                data[key] = value;
        });

        jobService.emailQueryResult(data)
            .then(response => {
                alert('Email sent!');
            })
            .catch(error => console.log(error));
    }

    getAccountOptions(accountCode) {

        if (!accountCode)
            return;

        accountService.getBookingOptions(accountCode)
            .then(response => {

                if (response.status === 200) {
                    var newState = Object.assign(this.state, {
                        accountOptions: response.data
                    });
            
                    this.setState(newState);
                }
            });
    }

    handleAccountChanged(accountCode) {

        this.getAccountOptions(accountCode);
    }

    render() {

        var privileges = null;
        var defaultAccount = null;
        var accountOptions = null;

        if (this.props.authenticatedUser) {
            privileges = this.props.authenticatedUser.privileges;
            defaultAccount = this.props.authenticatedUser.default_account;
            accountOptions = this.props.authenticatedUser.accounts;
        }

        var canAccessJobQuery = privileges && _.some(privileges, ['description', 'Job Query']);

        if (!canAccessJobQuery)
            return <Navigate to="/Welcome" />

        var canViewPrice = privileges && _.some(privileges, ['description', 'Can View Price']);
        var canViewDetails = privileges && _.some(privileges, ['description', 'Can View Details']);
        var canViewSignature = privileges && _.some(privileges, ['description', 'Can View Signatures']);

        return (
            <div id="jobs">
                <Navigation active="query" authenticatedUser={this.props.authenticatedUser} />
                <JobQuerySearchPanel defaultAccount={defaultAccount}
                    accountOptions={accountOptions}
                    onAccountChanged={this.handleAccountChanged}
                    onFormSubmit={this.onFormSubmit}
                    query={this.getPreviousQuery()} />
                <div className="padding-tb10" />
                <div className="container-fluid padding-lr55 bg-form flat">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
                            <EmailForm onSend={this.onSendEmail} />
                        </div>
                    </div>
                    <div className="padding-tb5" />
                </div>
                <div className="padding-tb10" />
                <div className="container-fluid padding-lr55">
                    <div className="row">
                        <div>
                            <span className="pull-right">Prices shown are GST exclusive</span>
                        </div>
                        <div style={{clear:"both"}}/>
                        <div className="col-xs-12">
                            <div id="jobQueryResults" styleName="styles.grid">
                                <Grid
                                    filterable={false}
                                    sortable={true}
                                    pageable={{ pageSizes: [25,50,100] }}
                                    data={this.state.jobs.data}
                                    total={this.state.jobs.total}
                                    skip={this.state.dataState.skip}
                                    pageSize={this.state.dataState.take}
                                    filter={this.state.dataState.filter}
                                    sort={this.state.dataState.sort}
                                    onDataStateChange={this.handleDataStateChange}
                                    onFetchData={this.onFetchData}
                                    resizable
                                >
                                    <GridColumn field="job_number" title="Job No." cell={(canViewDetails ? this.JobLinkCell : null)} width="80px" headerClassName="sortable" />
                                    <GridColumn field="ready_datetime" title="Job Date" cell={this.DateTimeCell} width="125px"  headerClassName="sortable" />
                                    <GridColumn field="caller_name" title="Booked By" width="100px"  headerClassName="sortable" />
                                    <GridColumn field="service_code" title="Service" sortable={false} width="80px" />
                                    <GridColumn field="reference1" title="Ref 1" width="160px" headerClassName="sortable" />
                                    <GridColumn field="reference2" title="Ref 2" width="160px" headerClassName="sortable" />
                                    <GridColumn field="pickup_suburb" title="From" width="200px" headerClassName="sortable" />
                                    <GridColumn field="delivery_suburb" title="To" width="200px" headerClassName="sortable" />
                                    <GridColumn field="status" title="Status" sortable={false} width="160px" />
                                    <GridColumn field="delivered_time" title="Del. Time" cell={this.DateTimeCell} sortable={false} width="125px" />
                                    {
                                        canViewSignature && <GridColumn field="delivered_sig_name" title="Sig. Name" width="80px" sortable={false} />
                                    }
                                    {
                                        canViewPrice && <GridColumn field="price" title="Price" filter="numeric" format="{0:c2}" width="100px" sortable={false} />
                                    }
                                    {
                                        canViewPrice && <GridColumn field="vfr" title="VFR" filter="numeric" format="{0:c2}" width="100px" sortable={false} />
                                    }
                                    {
                                        canViewPrice && <GridColumn field={null} title="Total" cell={this.TotalPriceCell.bind(this.formatter)} width="100px" sortable={false} />
                                    }
                                    {
                                        canViewPrice && this.state?.showTotalWithMarkup && <GridColumn field={null} title="Total with Markup" cell={this.TotalPriceWithMarkupCell.bind(this.formatter)} width="160px" sortable={false} />
                                    }
                                </Grid>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="padding-tb10" />
            </div>
        );
    }
}

const DecoratedQueryPage = withAuthenticatedUser(withRouter(QueryPage));

export { DecoratedQueryPage as QueryPage };